import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { User } from "../../interfaces/User.Interface";
import { ROUTES } from "../../routes/index";
import img from "../../svg/logo.svg";
import "./Header.Styles.scss";
import NavigationBar from "./NavigationBar.Component";
import UsermenuComponent from "./Usermenu.Component";
import profImg from "../../img/profile_default.jpg";

export default function HeaderComponent() {
  const location = useLocation();
  const history = useHistory();
  const firebase = useContext(firebaseContext);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const path = location.pathname.split("/")[1];
  const [active, setActive] = useState<string>(path ? path : "");

  const [activeUserMenu, setActiveUserMenu] = useState(false);
  const [activeNavigationMenu, setActiveNavigationMenu] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user as any);
      } else {
        setUser(null);
      }
      setLoading(false);
    });
  }, [firebase]);

  const activateUserMenu = () => {
    setActiveNavigationMenu(false);
    setActiveUserMenu(!activeUserMenu);
  };

  const activateNavigationMenu = () => {
    setActiveUserMenu(false);
    setActiveNavigationMenu(!activeNavigationMenu);
  };

  const renderHambergerIcon = () => {
    return (
      <div onClick={activateNavigationMenu} className="hamburger-icon">
        <div className="hamburger-div-1"></div>
        <div className="hamburger-div-2"></div>
        <div className="hamburger-div-3"></div>
      </div>
    );
  };

  const goToLogin = () => {
    history.push(ROUTES.loginScreen);
  };

  const renderUserIcon = () => {
    if (!loading)
      if (user) {
        return (
          <div onClick={activateUserMenu} className="user-image-container">
            <img src={user.photoURL || profImg} alt="" />
          </div>
        );
      } else {
        return (
          <div
            onClick={goToLogin}
            style={{ cursor: "pointer", padding: "5px" }}
          >
            <p>Login</p>
          </div>
        );
      }
  };

  const renderRightIcons = () => {
    return (
      <>
        {renderUserIcon()}
        {renderHambergerIcon()}
      </>
    );
  };

  return (
    <div className="header-container">
      <div className="logo-container">
        <img className="header-logo" src={img} alt="" />
      </div>
      <header className="header">
        <div className="header-content">
          <NavigationBar
            navigationActive={activeNavigationMenu}
            active={active}
            setActive={setActive}
          />
        </div>
      </header>
      <div className="header-right">{renderRightIcons()}</div>
      <div style={{ position: "relative" }}>
        <UsermenuComponent
          activeUserMenu={activeUserMenu}
          active={active}
          setActive={setActive}
        />
      </div>
    </div>
  );
}
